<section class="section-pd customAIBanner">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-12 col-lg-12">
                <div class="customAIContent">
                    <h1>打造您的專屬 AI 模型：<br/> 逐步流程解析</h1>
                    <p class="mt-4">從資料到部署——我們如何打造屬於您的 AI</p>
                    <div class="btn-group justify-content-center mt-40">
                        <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button" class="white-btn">立即打造您的專屬 AI 模型</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="custom-shape">
        <img src="/assets/images/custom-ai/custom-ai-banner.png" width="1833" height="611" alt="custom ai" />
    </div>
</section>

<section class="section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-9">
                <div class="trinka-title text-center">
                    <h2>逐步流程</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center match-box">
            <div class="col-lg-12 dflex">
                <div class="process-step gradient-bg data-collection c-card">
                    <span class="bg-number">01</span>
                    <div class="row">
                        <div class="col-md-8">
                            <h3>資料收集與清理</h3>   
                            <ul>
                                <li>我們會與您的企業緊密合作，收集訓練客製化 AI 模型所需的資料。</li>
                                <li>大多數企業資料為非結構化，需經過大量清理。</li>
                                <li>我們的團隊專長於準備準確、一致且與模型訓練相關的資料集。</li>
                            </ul>
                        </div>
                    </div>
                    <div class="ds-image">
                        <img src="/assets/images/custom-ai/data-collection.svg" class="img-fluid" alt="data collection" />
                    </div>  
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="process-step gradient-bg data-augmentation c-card">
                    <span class="bg-number bg-number2">02</span>
                    <div class="row">
                        <div class="col-md-12">
                            <h3>資料擴增</h3>   
                            <ul>
                                <li>對於資料量有限的組織，我們會採用資料擴增技術，生成合成資料，增加訓練資料的數量與多樣性。</li>
                                <li>此方法可避免過擬合，確保模型在有限資料下仍能良好泛化。</li>
                            </ul>
                        </div>
                    </div> 
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="process-step c-card">
                    <span class="bg-number bg-number3">03</span>
                    <div class="row">
                        <div class="col-md-12">
                            <h3>模型選擇與微調</h3>   
                            <ul>
                                <li>運用最先進的技術如 LoRA 和 QLoRA，我們對預訓練的開源模型進行微調，使其符合您的使用場景。</li>
                                <li>微調階段是確保模型能針對特定任務，產出準確且領域相關結果的關鍵步驟。</li>
                            </ul>
                        </div>
                    </div> 
                </div>
            </div>
            <div class="col-md-7 dflex">
                <div class="process-step gradient-bg data-collection c-card">
                    <span class="bg-number">04</span>
                    <div class="row">
                        <div class="col-md-8">
                            <h3>人類反饋強化學習（RLHF）</h3>   
                            <ul>
                                <li>我們專注於 RLHF，持續使用您團隊的反饋訓練模型。</li>
                                <li>這讓 AI 能更貼近您的業務流程，提高準確度並減少錯誤。</li>
                            </ul>
                        </div>
                    </div>
                    <div class="ds-image">
                        <img src="/assets/images/custom-ai/rlhf.svg" class="img-fluid" alt="rlhf" />
                    </div>  
                </div>
            </div>
            <div class="col-md-5 dflex">
                <div class="process-step c-card">
                    <span class="bg-number bg-number3">05</span>
                    <div class="row">
                        <div class="col-md-12">
                            <h3>評估與部署</h3>   
                            <ul>
                                <li>模型訓練完成後，透過自動化測試與專家評審嚴格評估。 </li>
                                <li>確保符合您的所有業務需求後，方進行部署。</li>
                                <li>模型會安全地部署於您指定的基礎設施，無論是本地端還是虛擬私人雲端。</li>
                            </ul>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd position-relative bg-light">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h2>為何這個方法奏效</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">我們全面的流程確保 AI 建立在乾淨且豐富的資料基礎上，並為您的特定需求量身微調。</p>
                    <p class="w-100">因此，模型不僅解決一般性問題，更能針對您企業最重要的挑戰提供解決方案。最重要的是——模型的所有權完全屬於您。</p>
                </div>
                <div class="btn-group justify-content-center mt-40">
                    <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button" class="filled-btn">聯繫我們</button>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="customAI_LearnMore hideCard3">
    <app-learn-more-section></app-learn-more-section>
</section>

<section class="section-pd custom-ai-gradient-light">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>想知道您的企業如何從專屬 AI 模型中受益？</h2>
                </div>
                <div class="btn-group justify-content-center mt-40">
                    <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button" class="filled-btn">歡迎與我們聯繫！</button>
                </div>
            </div>
        </div>
    </div>
</section>